import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import {
	type ClientPropertyHouseDetailResponseDTO,
	type ClientPropertyHouseEditRequestDTO,
	patchPropertyHouseIdV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const usePatchPropertyHouseMutation = (id: number) => {
	const queryClient = useQueryClient();

	return useMutation<
		ClientPropertyHouseDetailResponseDTO,
		Error,
		Partial<ClientPropertyHouseEditRequestDTO>
	>({
		mutationFn: processResponse((requestContract) =>
			patchPropertyHouseIdV2(requestContract, id),
		),
		onSuccess: (data) => {
			queryClient.invalidateQueries({
				queryKey: PortfolioKeys.propertyLists(),
			});
			queryClient.setQueryData(PortfolioKeys.propertyDetail(id), data);
		},
	});
};
